import React from 'react';
import PropTypes from 'prop-types';
import Image from 'apps/new-web/views/components/image';
import Icon from 'apps/new-web/views/components/icon';
import I18n from 'apps/new-web/views/components/i18n';
import CHECK_CIRCLE_SOLID from '@ifit/react-icons/dist/icons/CHECK_CIRCLE_SOLID';

const progressSections = [
  {
    label: I18n.translate('Account', 'Navigating through the account details sections of the activate flow'),
    totalPages: 1
  },
  {
    label: I18n.translate('Retailer', 'Navigating through the retailer sections of the activate flow'),
    totalPages: 1
  },
  {
    label: I18n.translate('Console', 'Navigating through the equipment console sections of the activate flow'),
    totalPages: 1
  },
  {
    label: I18n.translate('Activation', 'Navigating through the equipment activation sections of the activate flow'),
    totalPages: 2
  }
];

const Header = (props) => {
  const renderIcon = (index) => {
    const sectionIndex = props.sectionNumber - 1;

    if (sectionIndex > index) {
      return (
        <Icon
          className="scroll-icon"
          icon={ CHECK_CIRCLE_SOLID }
          color="#28E1A5"
          size={ 18 }
        />
      );
    } else if (sectionIndex < index) {
      return <div className="dot-inactive" />;
    } else {
      return <Image className="dot-active" src="/onboarding/activate/components/progress-header/img/dot-active.png" alt="" />;
    }
  };

  const renderProgressFill = (section, index) => {
    const sectionIndex = props.sectionNumber - 1;

    if (sectionIndex > index) {
      return { width: '100%' };
    } else if (sectionIndex < index) {
      return { width: 0 };
    } else {
      return { width: (props.pageNumber / section.totalPages * 100) + '%' };
    }
  };

  const renderMobileLabel = () => {
    let mobileLabel = null;

    if (progressSections[props.sectionNumber - 1]) {
      mobileLabel = <p className="active-label-mobile hide-on-tablet hide-on-desktop">{progressSections[props.sectionNumber - 1].label}</p>;
    }

    return mobileLabel;
  };

  return (
    <header className="progress-header">
      <div className="header-placeholder" />
      <div className="header-floating">
        <Image className="logo" src="/onboarding/activate/components/progress-header/img/ifit-logo.png" alt="iFIT" />
        {renderMobileLabel()}
        <div className="progress-container">
          { progressSections.map((section, index) => {
            return (
              <div className="progress-section" key={ section.label }>
                {renderIcon(index)}
                <p className={ (props.sectionNumber - 1) === index && 'active-label' } aria-hidden={ (props.sectionNumber - 1) !== index }>{section.label}</p>
                { index < progressSections.length && (
                  <div className="progress-bar">
                    <div className="progress-bar-fill" style={ renderProgressFill(section, index) } />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  pageNumber: PropTypes.number,
  sectionNumber: PropTypes.number
};

export default Header;
